import { Stack } from "@mui/material";
import type { FC } from "react";

interface LogoProps {
  logoImg: string;
  height?: number;
}

//import logoImg from "/img/logo.svg";
export const Logo: FC<LogoProps> = ({ logoImg, height = 32 }) => {
  return (
    <Stack alignItems="center" spacing={0.2} direction="row">
      <img src={logoImg} alt="logo" height={height} />
    </Stack>
  );
};
